import { RouteLocationNormalized, RouteLocationNamedRaw } from 'vue-router';
import { IFragmentDetails } from './IFragmentDetails';
import { IFragmentItem } from './IFragmentItem';
import { RouteParams } from './RouteParams';

export class RouteFragmentDetails implements IFragmentDetails {
	private readonly pathsByValue = new Map<string, string>();
	private readonly valuesByPath = new Map<string, string>();

	public constructor(public routeParam: RouteParams, items: readonly IFragmentItem[]) {
		for (const item of items) {
			this.index(item);
		}
	}

	public getPathPattern(): string {
		return `:${this.routeParam}(${this.getPathRestrictionsPattern()})`;
	}

	public tryDecodeFrom(destination: RouteLocationNormalized): Promise<string | undefined> {
		const encodedValue = destination.params?.[this.routeParam];
		if (encodedValue == null) {
			return Promise.resolve(undefined);
		}

		return Promise.resolve(this.getValueFrom(encodedValue as string));
	}

	public supports(value: string): Promise<boolean> {
		return Promise.resolve(this.getPathFrom(value) !== null);
	}

	public tryEncodeTo(value: string, navigationTarget: RouteLocationNamedRaw): Promise<boolean> {
		const path = this.getPathFrom(value);
		if (path == null) {
			return Promise.resolve(false);
		}

		navigationTarget.params ??= {};
		navigationTarget.params[this.routeParam] = path;

		return Promise.resolve(true);
	}

	private getPathFrom(value: string): string | undefined {
		return this.pathsByValue.get(value);
	}

	private getPathRestrictionsPattern(): string {
		return [...this.valuesByPath.keys()].join('|');
	}

	private index(item: IFragmentItem): void {
		this.pathsByValue.set(item.value, item.path);
		this.valuesByPath.set(item.path, item.value);

		for (const path of item.pathAlternatives) {
			this.valuesByPath.set(path, item.value);
		}
	}

	private getValueFrom(path: string): string | undefined {
		return this.valuesByPath.get(path);
	}
}
